// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_ep-j";
export var fulfillmentFormRail = "_ep-i";
export var headerTitleRow = "_ep-l";
export var orderDetailsWrapper = "_ep-g";
export var orderLinkTrigger = "_ep-2";
export var paymentInformationGrid = "_ep-q";
export var paymentSummaryColumn = "_ep-r";
export var phoneShipmentPickerButton = "_ep-e";
export var phoneShipmentPickerButtonContent = "_ep-f";
export var phoneShipmentPickerButtonWrapper = "_ep-d";
export var phoneShipmentPickerTrigger = "_ep-c";
export var shipmentContainer = "_ep-k";
export var shipmentDetailsMainPane = "_ep-h";
export var shipmentNavigationCard = "_ep-a";
export var shipmentNavigationEdgeTrigger = "_ep-6";
export var shipmentNavigationRail = "_ep-3";
export var shipmentNavigationRailEnter = "_ep-5";
export var shipmentNavigationRailHeader = "_ep-9";
export var shipmentNavigationRailOverlay = "_ep-4";
export var shipmentNavigationScrim = "_ep-7";
export var shipmentSummaryFact = "_ep-n";
export var shipmentSummaryGrid = "_ep-m";
export var shipmentSummaryMetadataRow = "_ep-o";
export var shipmentSummaryTags = "_ep-p";
export var shipmentWorkspace = "_ep-0";
export var shipmentWorkspaceBodyTablet = "_ep-8";
export var shipmentWorkspaceContent = "_ep-b";
export var shipmentWorkspaceHeader = "_ep-1";